import {
    eachDayOfInterval,
    endOfMonth,
    endOfWeek,
    format,
    isSameDay,
    isSameMonth,
    startOfMonth,
    startOfWeek,
  } from 'date-fns'
  import { ja } from 'date-fns/locale'
  import React, { useEffect } from 'react'
  import styled from 'styled-components'
  import { mutate } from 'swr';
  import {setSelectedDates as setSelectedDatesApi} from "../../options/setSelectedDates";
  import { useAuth } from 'hooks/use-auth';
  
  type CalendarProps = {
    date: Date
    defaultSelectedDates: Date[]
  }
  
  const WeekdaysRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  `
  
  const WeekdayCell = styled.div`
    width: calc(100% / 7);
    text-align: center;
  `
  
  const DayCell = styled.button<{ selected: boolean; grayed: boolean }>`
    border: solid 1px #999;
    width: calc(100% / 7);
    height: 35px;
    box-sizing: border-box;
    text-align: center;
    padding: 8px 0;
    cursor: ${({ grayed }) => (grayed ? 'not-allowed' : 'pointer')};
    color: ${({ grayed }) => (grayed ? '#999' : 'inherit')};
    background-color: ${({ selected }) => (selected ? '#D7000080' : 'transparent')};
  `
  
  const weekdaysShort = ['日', '月', '火', '水', '木', '金', '土']
  
  const CalendarMonth: React.FC<CalendarProps> = ({ date, defaultSelectedDates }) => {
    const auth = useAuth();
    const [selectedDates, setSelectedDates] = React.useState<Date[]>(
      defaultSelectedDates.filter(defaultSelectedDate => isSameMonth(date, defaultSelectedDate))
    )
  
    useEffect(() => {
      setSelectedDates(
        defaultSelectedDates.filter(defaultSelectedDate => isSameMonth(date, defaultSelectedDate))
      )
    }, [date, defaultSelectedDates])
  
    const handleDayClick = (day: Date) => {
      if (isSameMonth(day, date)) {
        setSelectedDates((prevSelectedDates) => {
          if (prevSelectedDates.some((selectedDate) => isSameDay(day, selectedDate))) {
            setSelectedDatesApi(day, false, auth.factoryId ,auth.authorizationHeader).then(() => {
              mutate(['/api/selectedDates', date])
            }).catch(() => {
              alert('更新に失敗しました。')
              mutate(['/api/selectedDates', date])
            })
            return prevSelectedDates.filter((selectedDate) => !isSameDay(day, selectedDate))
          } else {
            setSelectedDatesApi(day, true, auth.factoryId, auth.authorizationHeader).then(() => {
              mutate(['/api/selectedDates', date])
            }).catch(() => {
              alert('更新に失敗しました。')
              mutate(['/api/selectedDates', date])
            })
            return [...prevSelectedDates, day]
          }
        })
      }
    }
  
    const monthStart = startOfMonth(date)
    const monthEnd = endOfMonth(date)
    const startDate = startOfWeek(monthStart, { locale: ja })
    const endDate = endOfWeek(monthEnd, { locale: ja })
  
    const days = eachDayOfInterval({ end: endDate, start: startDate })
  
    return (
      <div style={{ width: 280 }}>
        <WeekdaysRow>
          {weekdaysShort.map((weekdayShort) => (
            <WeekdayCell key={weekdayShort}>{weekdayShort}</WeekdayCell>
          ))}
        </WeekdaysRow>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {days.map((day) => (
            <DayCell
              key={day.toISOString()}
              onClick={() => handleDayClick(day)}
              selected={selectedDates.some((selectedDate) => isSameDay(day, selectedDate))}
              grayed={!isSameMonth(day, date)}
              tabIndex={!isSameMonth(day, date) ? -1 : undefined}
            >
              {format(day, 'd')}
            </DayCell>
          ))}
        </div>
        <input
          name="selectedDates"
          type="hidden"
          value={selectedDates.map((selectedDate) => format(selectedDate, 'yyyy-MM-dd')).sort()}
        />
      </div>
    )
  }
  
  export default CalendarMonth
  